import {Command} from "../command";
import {CommandType} from "../commandType";
import * as _ from "lodash";
import * as ko from "knockout";
import {Application} from "../application";
import {ActivePanel} from "../state/activePanel";

export class CutRowCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.CutRow;
    
    canExecute = ko.computed(() => {
        let estimate = this.app.state.estimate();

        if (!estimate)
            return false;

        if (this.app.state.activePanel() == ActivePanel.Estimate) {
            let estimate = this.app.state.estimate();

            if (!estimate)
                return false;

            let selectedRow = estimate.selectedRow();
            if (selectedRow == null)
                return false;

            let totalRow = _.find(selectedRow, function(obj) {
                return obj.type > 1;
            });
            if (totalRow)
                return false;
            
            return selectedRow.length > 0;
        }

        return false;
    });

    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(pasteToTheEnd: boolean): JQueryPromise<any> {

        console.log("CutRow starting", this.canExecute(), this.app.state.activePanel() == ActivePanel.Estimate);

        this.app.commandsManager.execute(CommandType.RemoveEstimateRow);
        return this.app.commandsManager.execute(CommandType.CopyRow, pasteToTheEnd);
    }

    name = "Cut Row";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/cutRowCommand.ts